import baseService from '../shared/baseService';

const countryService = () => baseService('countries');

export default {
    countryService
};

